module.exports = __webpack_public_path__ + "static/fonts/Cactus-Bold-79f49d0e9d8ebbce8ac6269ff1549e47.otf";